// Client status values stored in the database
export const ClientStatus = {
  ONBOARDING: "onboarding",
  COURT_FILING: "court_filing",
  LETTERS_ISSUED: "letters_issued",
  NOTIFICATIONS: "notifications",
  ASSET_DISCOVERY: "asset_discovery",
  ADMINISTRATION: "administration",
  DISTRIBUTION: "distribution",
  FINAL_ACCOUNTING: "final_accounting",
} as const;

export type ClientStatusType = (typeof ClientStatus)[keyof typeof ClientStatus];

// Display configuration for each status
// Update labels here to change copy without touching the database
export const ClientStatusConfig: Record<ClientStatusType, { label: string; dotColor: string }> = {
  onboarding: {
    label: "Onboarding",
    dotColor: "bg-stone-400",
  },
  court_filing: {
    label: "Court Filing",
    dotColor: "bg-purple-400",
  },
  letters_issued: {
    label: "Letters Issued",
    dotColor: "bg-indigo-500",
  },
  notifications: {
    label: "Notifications",
    dotColor: "bg-blue-500",
  },
  asset_discovery: {
    label: "Asset Search",
    dotColor: "bg-teal-500",
  },
  administration: {
    label: "Administration",
    dotColor: "bg-yellow-500",
  },
  distribution: {
    label: "Distribution",
    dotColor: "bg-orange-500",
  },
  final_accounting: {
    label: "Final Accounting",
    dotColor: "bg-green-500",
  },
};

// Helper to get all statuses as options for dropdowns
export const getClientStatusOptions = () => {
  return Object.entries(ClientStatus).map(([, value]) => ({
    value,
    label: ClientStatusConfig[value].label,
  }));
};
